<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import AccountProvidersTable from "./AccountProvidersTable.svelte";
    import AccountPipVendorTable from "./AccountPipVendorTable.svelte";
    import AccountDefaultInsuranceCoverTable from "./AccountDefaultInsuranceCoverTable.svelte";
    import AccountActiveFundsTable from "./AccountActiveFundsTable.svelte";
    import { user } from "../../../stores";
    import { DirectUserRoles } from "../../../Utils/utilEnums.svelte";
    import ThirdPartyInsurer from "../../ThirdPartyInsurer/ThirdPartyInsurer.svelte";
    import { addIcon } from "../../../Utils/utilConstants.svelte";

    export let providerDetails = [];
    export let accountId = "";
    export let accountGroupId;
    export let reload = () => {};

    $: isUserEnableSeeThirdPartyInsurerTable = [
        DirectUserRoles.Admin,
        DirectUserRoles.Manager,
        DirectUserRoles.Support,
    ].includes($user.role);

    $: thirdPartyInsurerBtnOptions = thirdPartyInsurerRef
        ? [
              {
                  iconName: "addIcon",
                  hasTooltip: true,
                  tooltip: "Add Third Party Insurer",
                  iFont: addIcon,
                  iconFunction: () => addThirdPartyInsurer(),
                  btnText: "Add",
                  isHidden: accountThirdPartyInsurers?.length == 0,
              },
          ]
        : [];

    let thirdPartyInsurerRef, accountThirdPartyInsurers;

    onMount(async () => {
        await apiMethods.getMethod
            .getDeletedProviders(accountId)
            .then((res) => {
                providerDetails = [...providerDetails, ...res.results];
            });
    });

    const addThirdPartyInsurer = () => thirdPartyInsurerRef._openEditModal();
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 m-4">
        <AccountProvidersTable
            {providerDetails}
            {reload}
            {accountId}
            {accountGroupId}
        />

        <AccountPipVendorTable {providerDetails} {reload} />

        {#if isUserEnableSeeThirdPartyInsurerTable}
            <ThirdPartyInsurer
                bind:this={thirdPartyInsurerRef}
                bind:accountThirdPartyInsurers
                params={{
                    doctorId: accountId,
                }}
                isCardMode={true}
                cardModeConfig={{
                    title: "Third Party Insurer",
                    btnOptions: thirdPartyInsurerBtnOptions,
                }}
            />
        {/if}

        <AccountDefaultInsuranceCoverTable {accountId} />

        <AccountActiveFundsTable {accountId} />
    </div>
</div>
